import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getNotificationsByKind } from '../services/notificationApi';

/**
 * Hook pour charger les notifications d'un type spécifique depuis la BD
 * 
 * @param {string} kind - Type de notification ('company', 'suggestion', 'subscription', 'payment-proof')
 * @param {boolean} autoLoad - Charger automatiquement au mount (défaut: true)
 * @param {number} refreshInterval - Intervalle de rafraîchissement en ms (0 = pas de refresh auto)
 * @returns {object} { notifications, loading, error, refetch }
 */
export function useNotificationsByKind(kind, autoLoad = true, refreshInterval = 0) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const token = useSelector((state) => state.user?.accessToken || state.user?.token);

  const fetchNotifications = useCallback(async () => {
    if (!token || !kind) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getNotificationsByKind(kind);
      
      // Toute réponse qui n'est pas une liste (HTML, objet d'erreur...) ferait
      // planter les .map() du header, présent sur toutes les pages.
      setNotifications(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [kind, token]);

  // Chargement initial
  useEffect(() => {
    if (autoLoad) {
      fetchNotifications();
    }
  }, [autoLoad, fetchNotifications]);

  // Rafraîchissement automatique
  useEffect(() => {
    if (refreshInterval > 0) {
      const intervalId = setInterval(() => {
        fetchNotifications();
      }, refreshInterval);

      return () => clearInterval(intervalId);
    }
  }, [refreshInterval, fetchNotifications]);

  return {
    notifications,
    loading,
    error,
    refetch: fetchNotifications,
  };
}




























































































































































